/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import LoginPageLoadingIndicator from "./LoginPageLoadingOverlay";
import LoginPageAlert from "./LoginPageAlert";
import SmsVerify from "./SmsVerify";
import ExpirePassword from "./ExpirePassword";
import TermsOfUse from "../Modal/TermsOfUse";
import NumberFormat from "react-number-format";

import KvkkModal from "../shared/KvkkModal";
import {
  beginAuthenticate,
  beginControlCandidate,
  getIp,
  selectAuthenticate,
  beginAddLead,
  resetLeadSuccess,
  authenticateOtp,
} from "../../../state/ducks/login/index";
import { hideModal, selectAlertMessage } from "../../../state/ducks/alert/index";
import ReactPixel from "react-facebook-pixel";

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import { applyLoginPageBody } from "./loginPageBody";
import LoginBrandPanel from "./LoginBrandPanel";

function validateLeadForm(name, surname, gsmControl, kvkkIzni) {
  const messages = [];

  if (!/^[a-zA-Z_ğüşıöçĞÜŞİÖÇ ]+$/.test(name)) {
    messages.push("Lütfen geçerli bir Ad giriniz.");
  }

  if (!/^[a-zA-Z_ğüşıöçĞÜŞİÖÇ ]+$/.test(surname)) {
    messages.push("Lütfen geçerli bir Soyad giriniz.");
  }

  if (!gsmControl) {
    messages.push("Lütfen geçerli bir GSM numarası giriniz.");
  }

  if (!kvkkIzni) {
    messages.push("Kişisel verilerin korunması aydınlatma ve bilgilendirmesi onayı boş bırakılamaz.");
  }

  return messages;
}

const normalizeLoginUsername = (value) =>
  String(value || "").replace(/_/g, "").replace(/\D/g, "");


class Login extends Component {
  state = {
    userName: "",
    password: "",
    gsm: "",
    loginType: 1,
    platform: "web",
    token: "",
    corporate: this.props.match.params.type === "corporate",
    candidate: this.props.match.params.type === "aday",
    corporateCss: "",

    name: "",
    surname: "",
    reklamIzni: false,
    kvkkIzni: false,
    gsmControl: false,
    ip: "",
    isKvkkModalOpen: false,
    isTermsModalOpen: false,
    localAlert: null,
  };

  clearAlerts = () => {
    this.props.hideModal();
    this.setState({ localAlert: null });
  };

  dismissAlert = () => {
    if (this.props.alert?.redirect) {
      this.props.history.push(this.props.alert.redirect);
    }
    this.clearAlerts();
  };

  getAlertDisplay = () => {
    const { alert } = this.props;
    const { localAlert } = this.state;

    if (alert?.isOpen && alert?.message) {
      return {
        type: alert.type === "success" ? "success" : "error",
        messages: alert.message,
      };
    }

    if (localAlert) {
      return localAlert;
    }

    return null;
  };

  loginChangeType() {
    var loginPassword = document.getElementById("loginPassword");
    var iconLoginPassword = document.getElementById("iconLoginPassword");
    if (iconLoginPassword != null && loginPassword != null) {

      if (loginPassword.type == 'password') {
        loginPassword.type = 'text';

        iconLoginPassword.classList.remove("t-icon-eye-blocked");
        iconLoginPassword.classList.add("t-icon-eye");
      } else {
        loginPassword.type = 'password';
        iconLoginPassword.classList.remove("t-icon-eye");
        iconLoginPassword.classList.add("t-icon-eye-blocked");
      }
    }

  };

  beginAuthenticate = (event) => {
    event.preventDefault();
    const postData = {
      username: normalizeLoginUsername(this.state.userName),
      password: this.state.password,
      loginType: this.state.loginType,
      platform: this.state.platform,
      token: this.state.token,
      authType: 1,
    };
    this.props.beginAuthenticate(postData);
    this.setState({
      userName: "",
      password: "",
    });

    this.createCaptchaToken();

  };

  authenticateOtp = (event) => {
    event.preventDefault();
    this.clearAlerts();
    const postData = {
      username: normalizeLoginUsername(this.state.userName),
      password: this.state.password,
      platform: this.state.platform,
      token: this.state.token,
      verifyType: 1,
    };
    this.props.authenticateOtp(postData);
    this.setState({
      userName: "",
      password: "",
    });
    this.createCaptchaToken();
  };

  beginControlCandidate = (event) => {
    event.preventDefault();

    var control = true;
    var adayTelefonNo = document.getElementById('adayTelefonNo').value;
    var adaytelno = adayTelefonNo.replace(/\D/g, ''); // sayılar dışındaki tüm karakterleri siliyorum

    if (adaytelno.length < 10) {
      document.getElementById('adayTelefonNo').parentElement.classList.add("t-error"); // kutunun içini kırmızız yapıyorum.
      document.getElementById("adayTelefonNo").nextElementSibling.innerHTML = "<i class='t-icon-error text-danger'></i>";
      control = false;
    }
    const postData = {
      username: this.state.gsm,
      loginType: 1,
      platform: this.state.platform,
      token: this.state.token,
      authType: 2,
    };

    if (control) {
      this.props.beginControlCandidate(postData);
    }

    this.createCaptchaToken();
  };
  getIpAdress() {
    getIp().then(
      response => {
        this.setState({ ip: response });
      },
      error => { }
    );
  }



  getKvkk = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ isKvkkModalOpen: true });
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  openTermsModal = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ isTermsModalOpen: true });
  };

  closeTermsModal = () => {
    this.setState({ isTermsModalOpen: false });
  };

  componentDidMount() {
    this.getIpAdress();
    if (this.state.corporate === true) {
      this.setState({ corporateCss: "-krmsl" });
      this.props.history.push("/giris/Corporate");
    } else {
      this.props.history.push("/giris");
    }
    applyLoginPageBody();
    ReactPixel.init("210664537388285");
    ReactPixel.pageView();
    this.createCaptchaToken();
    this.props.resetLeadSuccess();

    var LoggingInFromDifferentBrowser = sessionStorage.getItem("LoggingInFromDifferentBrowser");
    if (LoggingInFromDifferentBrowser == "true") {
      sessionStorage.setItem("LoggingInFromDifferentBrowser", false);
      this.setState({
        localAlert: {
          type: "error",
          messages: [
            "Başka bir ortamdan oturum açıldığı için oturumunuz sonlandırılmıştır. Giriş yaparak işleminize devam edebilirsiniz.",
          ],
        },
      });
    }

  }

  componentDidUpdate() {
    if (this.props.login?.controlCandidate) {
    } else if (this.props.login?.controlNewCandidate) {
      this.props.history.push("/yeniuyelik");
    }
  }

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }

  setReklamIzni = (e) => {
    this.setState({
      reklamIzni: e.target.checked,
    });
  };
  setKvkk = (e) => {
    this.setState({
      kvkkIzni: e.target.checked,
    });
  };

  beginAddLead = (event) => {
    event.preventDefault();

    const validationMessages = validateLeadForm(
      this.state.name,
      this.state.surname,
      this.state.gsmControl,
      this.state.kvkkIzni
    );

    if (validationMessages.length > 0) {
      this.props.hideModal();
      this.setState({
        localAlert: {
          type: "error",
          messages: validationMessages,
        },
      });
      return;
    }

    this.clearAlerts();
    var adaytelno = this.state.gsm.replace(/\D/g, '');
    const postData = {
      adi: this.state.name,
      soyadi: this.state.surname,
      tel: adaytelno,
      acikRizaIzni: this.state.kvkkIzni,
      reklamIzni: this.state.reklamIzni,
      token: this.state.token,
    };
    this.props.beginAddLead(postData);
  };


  render() {
    const { login } = this.props;
    const alertDisplay = this.getAlertDisplay();
    const loadingSubtext = login.leadSubmitting
      ? "Bilgileriniz kaydediliyor, lütfen bekleyiniz..."
      : login.controlSmsVerify || login.controlEpostaVerify
        ? "Doğrulama işleminiz gerçekleştiriliyor..."
        : "Giriş yapılıyor, lütfen bekleyiniz...";
    const isVerifyStep = login.controlSmsVerify || login.controlEpostaVerify;

    return (
      <>
        <div className="t-loginPage t-loginPage--split">
          <LoginBrandPanel />

          <main className="t-loginPage-main">
            <LoginPageLoadingIndicator active={login.loggingIn} subtext={loadingSubtext} />
            <div className="t-loginPage-mainScroll">
              <div className="t-loginPage-mainInner">
                <div className="t-loginPage-mainLogoWrap">
                  <img
                    src="/assets/img/svg/logo_internetSube-dark.svg"
                    alt="Eminevim İnternet Şube"
                    className="t-loginPage-mainLogo"
                  />
                </div>
                {isVerifyStep ? (
                  <SmsVerify />
                ) : (
                  <>
                <header className="t-loginPage-head t-loginPage-head--welcome">
                  <h1 className="t-loginPage-title">Hoş geldiniz</h1>
                  <p className="t-loginPage-subtitle">Devam etmek için hesap bilgilerinizi girin.</p>
                </header>

                {alertDisplay ? (
                  <LoginPageAlert
                    messages={alertDisplay.messages}
                    type={alertDisplay.type}
                    onDismiss={this.dismissAlert}
                  />
                ) : null}

                <div className="t-loginPage-tabs nav nav-pills" id="pills-tab" role="tablist">
                  <a
                    className="t-loginPage-tab active"
                    id="pills-home-tab"
                    data-toggle="pill"
                    data-target="#loginUye"
                    role="tab"
                    aria-controls="loginUye"
                    aria-selected="true"
                  >
                    <i className="t-icon-profile" aria-hidden="true" />
                    Üyeliğim Var
                  </a>
                  <a
                    className="t-loginPage-tab"
                    id="pills-profile-tab"
                    data-toggle="pill"
                    data-target="#loginAday"
                    role="tab"
                    aria-controls="loginAday"
                    aria-selected="false"
                    onClick={() => {
                      this.props.resetLeadSuccess();
                      this.clearAlerts();
                      this.setState({
                        name: "",
                        surname: "",
                        gsm: "",
                        gsmControl: false,
                        kvkkIzni: false,
                        reklamIzni: false,
                      });
                    }}
                  >
                    <i className="t-icon-user-plus" aria-hidden="true" />
                    Aday Müşteri
                  </a>
                </div>

                <div className="tab-content" id="pills-tabContent">
                  <div className="tab-pane fade show active" id="loginUye" role="tabpanel">
                    <form onSubmit={this.authenticateOtp} className="t-loginPage-form">
                      <div className="t-loginPage-field">
                        <label className="t-loginPage-label" htmlFor="userName">TC Kimlik / VKN / Üye No</label>
                        <div className="t-resetPassword-inputWrap">
                          <span className="t-resetPassword-inputIcon">
                            <i className="t-icon-account_box" aria-hidden="true" />
                          </span>
                          <NumberFormat
                            id="userName"
                            displayType={"input"}
                            autoComplete="new-password"
                            className="decimalnumber"
                            maxLength={11}
                            placeholder="T.C. Kimlik / VKN / Üye No"
                            value={this.state.userName}
                            onChange={(e) => {
                              this.setState({
                                userName: normalizeLoginUsername(e.target.value),
                              });
                            }}
                          />
                        </div>
                      </div>

                      <div className="t-loginPage-field">
                        <label className="t-loginPage-label" htmlFor="loginPassword">Şifre</label>
                        <div className="t-resetPassword-inputWrap">
                          <span className="t-resetPassword-inputIcon">
                            <i className="t-icon-lock1" aria-hidden="true" />
                          </span>
                          <input
                            type="password"
                            id="loginPassword"
                            placeholder="Şifrenizi giriniz"
                            autoComplete="new-password"
                            value={this.state.password}
                            onChange={(e) => {
                              this.setState({ password: e.target.value });
                            }}
                          />
                          <span className="t-resetPassword-inputIcon">
                            <i
                              id="iconLoginPassword"
                              className="t-icon-eye-blocked t-cursorPointer"
                              onClick={this.loginChangeType}
                              role="button"
                              tabIndex={0}
                              aria-label="Şifreyi göster"
                              onKeyDown={(e) => e.key === "Enter" && this.loginChangeType()}
                            />
                          </span>
                        </div>
                      </div>

                      <div className="t-loginPage-actions">
                        <Link
                          to={this.state.corporate ? "/sifremiunuttum/corporate" : "/sifremiunuttum"}
                          className="t-loginPage-link"
                        >
                          Şifre Al / Şifremi Unuttum
                        </Link>
                      </div>

                      <button type="submit" className="t-loginPage-submit">
                        GİRİŞ YAP
                      </button>

                      <div className="t-loginPage-notice">
                        <i className="t-icon-lock1" aria-hidden="true" />
                        <span>
                          Kişisel bilgilerinizi kimseyle paylaşmayın. Güçlü ve benzersiz bir şifre kullanın, düzenli olarak güncelleyin.
                        </span>
                      </div>
                    </form>
                  </div>

                  <div className="tab-pane fade" id="loginAday" role="tabpanel">
                    {login.leadSuccess ? (
                      <div className="t-loginPage-success">
                        <i className="t-icon-check_circle" aria-hidden="true" />
                        <div>
                          Bilgileriniz başarılı şekilde alınmıştır. En kısa zamanda sizinle iletişime geçilecektir.
                        </div>
                      </div>
                    ) : (
                      <div className="t-loginPage-form">
                        <p className="t-loginPage-candidateLead">Formu gönderin, sizi arayalım</p>

                        <div className="t-loginPage-field">
                          <label className="t-loginPage-label" htmlFor="adayAdi">Adınız</label>
                          <div className="t-resetPassword-inputWrap">
                            <span className="t-resetPassword-inputIcon"><i className="t-icon-user" aria-hidden="true" /></span>
                            <input
                              id="adayAdi"
                              type="text"
                              placeholder="Adınızı giriniz"
                              required
                              value={this.state.name}
                              onChange={(e) => this.setState({ name: e.target.value })}
                            />
                          </div>
                        </div>

                        <div className="t-loginPage-field">
                          <label className="t-loginPage-label" htmlFor="adaySoyadi">Soyadınız</label>
                          <div className="t-resetPassword-inputWrap">
                            <span className="t-resetPassword-inputIcon"><i className="t-icon-user" aria-hidden="true" /></span>
                            <input
                              id="adaySoyadi"
                              type="text"
                              placeholder="Soyadınızı giriniz"
                              required
                              value={this.state.surname}
                              onChange={(e) => this.setState({ surname: e.target.value })}
                            />
                          </div>
                        </div>

                        <div className="t-loginPage-field">
                          <label className="t-loginPage-label">Telefon Numaranız</label>
                          <div className="t-loginPage-phoneWrap">
                            <PhoneInput
                              country="tr"
                              value={this.state.gsm}
                              placeholder="+90 500 000 00 00"
                              buttonStyle={{ border: "none", background: "transparent" }}
                              inputClass="new-phone-input"
                              countryCodeEditable={false}
                              onChange={(value, data, event, formattedValue) => {
                                this.setState({
                                  gsm: value.replace(/\D/g, ""),
                                  gsmControl:
                                    (data.format.length > 20 && formattedValue.length === 20) ||
                                    data.format.length === formattedValue.length,
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="t-loginPage-consent">
                          <input
                            type="checkbox"
                            id="kvkk_check"
                            name="kvkk_check"
                            onChange={this.setKvkk}
                            checked={this.state.kvkkIzni}
                            required
                          />
                          <span>
                            <a href="#" className="t-loginPage-link" onClick={this.getKvkk}>
                              Kişisel verilerin korunması aydınlatma ve bilgilendirmesi
                            </a>
                            &apos;ni okudum, kabul ediyorum.
                          </span>
                        </div>

                        <div className="t-loginPage-consent">
                          <input
                            type="checkbox"
                            id="reklam_check"
                            name="reklam_check"
                            onChange={this.setReklamIzni}
                            checked={this.state.reklamIzni}
                          />
                          <span>
                            Kampanyalardan haberdar olmak için Emin Üstün Holding Şirketleri&apos;nden ticari elektronik ileti almak istiyorum.
                          </span>
                        </div>

                        <button type="submit" className="t-loginPage-submit" onClick={this.beginAddLead}>
                          Bilgilerimi Gönder
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                  </>
                )}
              </div>
            </div>

            <footer className="t-loginPage-mainFooter">
              <div className="t-loginPage-mainFooter-links">
                <a href="#" className="t-loginPage-footerLink" onClick={this.getKvkk}>Kişisel Verilerin Korunması</a>
                <span className="t-loginPage-footerSep" aria-hidden="true" />
                <a href="#" className="t-loginPage-footerLink" onClick={this.openTermsModal}>
                  Kullanım Koşulları
                </a>
              </div>
              <div className="t-loginPage-mainFooter-meta">
                {this.state.ip ? <span>{this.state.ip}</span> : null}
                <span>© EMİNEVİM</span>
              </div>
            </footer>
          </main>
        </div>

        <TermsOfUse isOpen={this.state.isTermsModalOpen} onClose={this.closeTermsModal} />
        <KvkkModal isOpen={this.state.isKvkkModalOpen} onClose={this.closeKvkkModal} />
        <ExpirePassword />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alert: selectAlertMessage(state),
    login: selectAuthenticate(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  beginAuthenticate: (postData) => dispatch(beginAuthenticate(postData)),
  beginControlCandidate: (postData) =>
    dispatch(beginControlCandidate(postData)),
  beginAddLead: (postData) => dispatch(beginAddLead(postData)),
  resetLeadSuccess: () => dispatch(resetLeadSuccess()),
  authenticateOtp: (postData) => dispatch(authenticateOtp(postData)),
  hideModal: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
